import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import * as Styled from "./style.components";
import { 
    IBackArrow, INextArrow
} from "../../../assets";
import { ShimmerPostDetails } from "react-shimmer-effects";
import { getFormTypesAction } from "../../../store/actions";
import { SnackBar } from "../../../components/shared";

const QuestionnaireType = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [formTypesArray, setFormTypesArray] = useState([{}]);

    useEffect(() => {
        fetchFormTypes();
    },[dispatch]);

    const fetchFormTypes = async () => {
        setIsLoading(true);
        try {
            const response = await dispatch(getFormTypesAction()).unwrap();
            const newFormTypes = response?.result;
            setFormTypesArray(newFormTypes);
        } catch (error) {
            console.error("Failed to fetch form types:", error);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
        <Styled.Container>
            <ShimmerPostDetails card cta variant="SIMPLE" />;
        </Styled.Container>
        );
    }

    return (
        <Styled.Container>
          <Styled.TopHeader>
            <Styled.ArrowBackImage 
              src={IBackArrow} 
              alt="back-arrow" 
              onClick={() => navigate(-1)}
            />
            Add Questionnaire
          </Styled.TopHeader>
          <Styled.TypeContainer>
            <Styled.TypeText>Select the type</Styled.TypeText>
            <Styled.TypeList>
                {formTypesArray.map((formType) => (
                    <Styled.TypeListText 
                    id={formType?.id}
                    onClick={() =>
                        navigate("questionnaire-form", {
                        state: { form_id: formType?.id, form_type: formType?.title},
                        })
                    }>
                        {formType?.title}
                        <Styled.NextArrowIcon src={INextArrow}></Styled.NextArrowIcon>
                    </Styled.TypeListText>
                ))}
            </Styled.TypeList>
          </Styled.TypeContainer>
          <SnackBar />
        </Styled.Container>
    )
}
export default QuestionnaireType;